module.exports = __webpack_public_path__ + "static/media/SAM_1069.c3d2da1a.JPG";